import React, { Component, Fragment } from 'react';

export default class SharePrice extends Component {
    render() {
        return (
            <Fragment>
                <iframe
                    title="share-price"
                    allowtransparency="true"
                    marginHeight="0"
                    marginWidth="0"
                    className="responsive padded share-price"
                    id="ExternalWebContentExternalIFrame"
                    src="https://irs.tools.investis.com/Clients/uk/jdplc/SM8/Default.aspx?culture=en-GB"
                    frameBorder="0"
                    height="1010"
                    width="100%"
                ></iframe>
            </Fragment>
        );
    }
}
